'use client';
import { useState } from 'react';

import UploadPdf from './components/UpLoadPdf';
import VerifyDetail from './components/VerifyDetail';

const Page = () => {
  const [isValidate, setIsValidate] = useState(false);
  const [file, setFile] = useState<File>();
  return (
    <>
      {isValidate ? (
        <VerifyDetail
          file={file!}
          onValidateOther={() => {
            setIsValidate(false);
          }}
        ></VerifyDetail>
      ) : (
        <UploadPdf
          onValidate={(file) => {
            setIsValidate(true);
            setFile(file);
          }}
        ></UploadPdf>
      )}
    </>
  );
};

export default Page;
